<template>
    <div id="gallery_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Gallery</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
                    <router-link v-if="canAddGallery" class="btn btn-primary pull-right"
                        v-bind:to="{ name: 'GalleryCreate' }"> <i class="fp-add"> </i> Upload</router-link>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content gallery-list">
                        <data-table-filter-config :moduleName="'galleryList'" :removeLineButtonVisibility="true"
                            :addFilterButtonVisibility="true" @cancelSelection="cancelAll"
                            :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                :moduleName="'galleryList'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table ref="listGallery" mode="remote" title="Gallery"
                                @on-page-change="onPageChange" @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange" :totalRows="totalRecords" :columns="userColumns"
                                :rows="rows" :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown: dropDownPerPage,
                                    dropdownAllowAll: false,
                                }" :select-options="{
                                    enabled: deleteBtnAccess,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }" :search-options="{
                                    enabled: false,
                                }">

                                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <router-link title="Edit Media" class="fp-edit"
                                                v-bind:to="{ name: 'GalleryEdit', params: { id: props.row.id } }"></router-link>
                                        </div>
                                        <div v-else-if="props.column.field == 'link'">
                                            <a v-on:click="goToGetDocumentPath($event, props.row)" title="View Media(s)"
                                                href="" style="font-size: 15px;"><i class="fp-text-document"></i></a>
                                        </div>
                                        <div v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                        </div>
                                    </div>
                                </template>

                                <div slot="selected-row-actions">
                                    <button v-if="deleteBtnAccess" id="deleteGalleryBtn"
                                        v-on:click.prevent="galleryDelete" class="btn btn-primary">Delete</button>
                                </div>
                            </vue-good-table>
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "../event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import { commonMixins } from '../../mixins/commonMixins';
import { dataTableMixins } from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';

export default {
    name: "GalleryList",
    components: {
        customPagination: () => import('@/components/layout/CustomPagination'),
        dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
        clearCacheData: () => import('@/components/ClearCacheData'),
        appFooter: () => import('@/components/Footer'),
    },
    mixins: [commonMixins, dataTableMixins, contractMixins],
    metaInfo() {
        return { title: "Gallery | " + process.env.COPYRIGHT_NAME }
    },
    data: () => ({
        permissions: [],
        cantAccessPage: '',
        userColumns: [],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                filterable: false,
                hidden: false,
                width: '100px'
            },
            {
                label: 'Title',
                field: 'title',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Title", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Media Link',
                field: 'link',
                sortable: false,
                filterable: false,
                width: '200px'
            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created At", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                width: '250px'
            },
            {
                label: 'Created By',
                field: 'created_by',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                width: '250px'
            }
        ],
        rows: [],
        totalRecords: 0,
        deleteBtnAccess: false,
        loading: false,
        canEditGallery: false,
        canAddGallery: false,
        pageKey: "_gallery_list_",
        errorMsg: "",
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                self.cantAccessPage = true;
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_create_media') {
                        self.canAddGallery = true;
                    }
                    if (permissions[i].name == 'ev_edit_media') {
                        self.canEditGallery = true;
                    }
                    if (permissions[i].name == 'ev_delete_media') {
                        self.deleteBtnAccess = true;
                    }
                }
            }
        },
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
    },
    methods: {
        cancelAll: function () {
            this.$refs.listGallery.unselectAllInternal();
        },

        selectionChanged(param) {
            if (param.selectedRows.length == 100) {
                EventBus.$emit('clear-selection', false);
            } else {
                EventBus.$emit('clear-all-flags', false);
            }
        },
        loadList() {
            var self = this;
            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
            };
            $.ajax({
                url: process.env.ROOT_API + "/media-gallery/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'gallery-list');
                }
            });
        },
        galleryDelete() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this gallery item?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    var data = this.$refs['listGallery'].selectedRows;
                    var use = [];
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['listGallery'].selectedRows[i].id)
                    }
                    self.loading = true;
                    $("#deleteGalleryBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/media-gallery/delete",
                        type: "POST",
                        data: 'ids=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                                $("#deleteGalleryBtn").val("Delete");
                            }, 1000);
                            if (data.code == '200') {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, false, 'gallery-item-delete');
                        }
                    });
                }
            });
        },
        goToGetDocumentPath(event, row) {
            event.preventDefault();
            var self = this;
            var path = row.link;
            var flag = 'gallery';
            var id = 0;
            if (row.id > 0) {
                id = row.id;
            }

            self.getDocumentPath(id, path, flag);
        }
    }
};
</script>
<style scoped>
.data-table table.vgt-table .fp-log-file-format {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/gallery/GalleryList.vue